export const environment = {
    production: false,
    API_URL: 'https://intellimaid-api.elgibor-solution.com',
    STORAGE_BASE_URL: 'https://intellimaid-api.elgibor-solution.com',
    WORDPRESS_URL: 'https://intellimaid.elgibor-solution.com',
    PLACEHOLDER_IMAGE_URL: 'https://placehold.co',
    googleMapsApiKey: 'AIzaSyBSXyW5J16JmrDZiFtDHVkehubeb75C_XE',
    googleMapId: '76a2690a0bc18677d17fc4a7',
    firebaseConfig: {
        apiKey: 'AIzaSyA3brpIHC5Ots-M6Ofesy30ksTv3XoU2kk',
        authDomain: 'intellimaid.firebaseapp.com',
        projectId: 'intellimaid',
        storageBucket: 'intellimaid.firebasestorage.app',
        messagingSenderId: '141678267390',
        appId: '1:141678267390:web:6588ab6d3ed73631ed8eaf',
    },
};
